import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrderContractTaskActivity } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0920. 発注案件契約タスクアクティビティ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id/purchase_order_contract_task_activities
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const purchaseOrderContractTaskActivities = (props: Props): Promise<PurchaseOrderContractTaskActivity[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}/purchase_order_contract_task_activities`
  );
};

export const usePurchaseOrderContractTaskActivities = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderContractTaskActivities(props),
  });
};

export const usePurchaseOrderContractTaskActivitiesInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'purchase_order_contract_tasks',
    props.id,
    'purchase_order_contract_task_activities',
  ];
};
